import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/adminNav.css";
import Logo from "../assets/logo.png";
import axios from "axios";
import { Newspaper, Home as HomeIcon, LogOut } from "lucide-react"; 

// Dropdown Component
const DropdownMenu = ({ title, index, openIndex, setOpenIndex, children }) => {
  const isOpen = openIndex === index;

  const toggleDropdown = () => {
    setOpenIndex(isOpen ? null : index);
  };

  return (
    <div className={`dropdown-menu ${isOpen ? "open" : ""}`}>
      <p onClick={toggleDropdown} className="dropdown-title">
        {title}
        <span className={`arrow ${isOpen ? "rotate" : ""}`}>▼</span>
      </p>
      {isOpen && <ul className="dropdown-list">{children}</ul>}
    </div>
  );
};

const AdminNav = () => {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("username");
  const storedBranch = localStorage.getItem("branch");
  const storedMemId = localStorage.getItem("memberId");
  const siteName  = localStorage.getItem("company");

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // state for all menus
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    fetchData();
    fetchData1();
    fetchData2();
    
  }, [storedMemId]);

  // --- Utility fetcher that supports wrapped/array ---
  const safeSetData = (setter, response, keyName) => {
    if (Array.isArray(response.data)) {
      setter(response.data);
    } else if (response.data && Array.isArray(response.data[keyName])) {
      setter(response.data[keyName]);
    } else {
      setter([]); // fallback
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/vehicle_navMaster?memId=${storedMemId}`
      );
      safeSetData(setData, response, "vehicleMaster");
    } catch (error) {
      console.error("Error Fetching Master:", error);
    }
  };

  const fetchData1 = async () => {
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/vehicle_navTrans?memId=${storedMemId}`
      );
      safeSetData(setData1, response, "vehicleTrans");
    } catch (error) {
      console.error("Error Fetching Trans:", error);
    }
  };

  const fetchData2 = async () => {
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/vehicle_navReport?memId=${storedMemId}`
      );
      safeSetData(setData2, response, "vehicleRpt");
    } catch (error) {
      console.error("Error Fetching Trans:", error);
    }
  };

  

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("branch");
    navigate("/login", { replace: true });
  };

  return (
    <div className={`admin-nav-container ${isMenuOpen ? "open" : ""}`}>
      {/* Top Header (Mobile) */}
      <div className="admin-nav-header">
        <img src={Logo} alt="logo" className="school--logo-mobile" />
        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>

      {/* Sidebar */}
      <div id="nav-container" className={`${isMenuOpen ? "show" : ""}`}>
        <div className="img-flex">
          <div className="logo-container">
            <img src={Logo} alt="logo" className="school--logo" />
          </div>
        </div>

        <div className="user-info">
           <p>
            Company: <b>{siteName}</b>
          </p>
          <p>
            User: <b>{storedUser}</b>
          </p>
          <p>
            Branch: <b>{storedBranch}</b>
          </p>
        </div>

        <div className="content-left">
          <ul>
            {/* Master */}
            <DropdownMenu
              title="Master Module"
              index={0}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              {data.map((item, idx) => (
                <Link key={idx} to={`/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>

            {/* Transaction */}
            <DropdownMenu
              title="Transaction"
              index={1}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              {data1.map((item, idx) => (
                <Link key={idx} to={`/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>

            {/* Report */}
            <DropdownMenu
              title="Report"
              index={2}
              openIndex={openDropdown}
              setOpenIndex={setOpenDropdown}
            >
              {data2.map((item, idx) => (
                <Link key={idx} to={`/${item.links}`}>
                  <li>{item.title}</li>
                </Link>
              ))}
            </DropdownMenu>
          </ul>
        </div>

         <div className="nav_buttons">
          {/* Logout on top */}
           <div className="nav-quick">
            <Link to="/components/flashNews">
              <button className="flash-btn">
                <Newspaper size={16} className="ico" />
                Flash News
              </button>
            </Link>

            <Link to="/home">
              <button className="home-btn">
                <HomeIcon size={16} className="ico" />
                Home
              </button>
            </Link>
          </div>
          <button onClick={handleLogout} className="logout">
            <LogOut size={16} className="ico" />
            Logout
          </button>

          {/* Quick actions row (Flash + Home) below */}
         
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
